export default "__VITE_ASSET__CNTRXgT0__"